import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usePromotion } from '../hooks/useFirestoreData';
import './EventDetailPage.css';

function PromotionDetailPage({ setWompiPaymentHandler, setBankTransferHandler }) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const { promotion, loadingPromotion } = usePromotion(id, setError);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedDate, setSelectedDate] = useState('');

    useEffect(() => {
        if (promotion && promotion.dates && promotion.dates.length > 0) {
            setSelectedDate(promotion.dates[0]); // Set the first date as default
        }
    }, [promotion]);

    useEffect(() => {
        if (selectedOption && promotion) {
            const handleWompiPayment = async (customerData) => {
                console.log("Wompi for promotion", { promotion, selectedOption, selectedDate, customerData });
                // Here you would integrate with Wompi, similar to App.js
            };

            const handleBankTransfer = async (customerData) => {
                console.log("Bank transfer for promotion", { promotion, selectedOption, selectedDate, customerData });
                // Here you would save the booking with 'pending transfer' status
            };

            setWompiPaymentHandler(() => handleWompiPayment);
            setBankTransferHandler(() => handleBankTransfer);
        }
    }, [selectedOption, promotion, selectedDate, setWompiPaymentHandler, setBankTransferHandler]);

    const openModal = (option) => {
        setSelectedOption(option);
    };

    const closeModal = () => {
        setSelectedOption(null);
    };

    const handleBookNowInModal = (option) => {
        if (!selectedDate && promotion.dates && promotion.dates.length > 0) {
            alert('Por favor, selecciona una fecha para la promoción.');
            return;
        }
        localStorage.setItem('selectedPromotionForCheckout', JSON.stringify(promotion));
        localStorage.setItem('selectedPromotionOptionForCheckout', JSON.stringify(option));
        localStorage.setItem('selectedPromotionDateForCheckout', selectedDate);
        navigate('/checkout');
        closeModal();
    };

    if (loadingPromotion) {
        return <p>Cargando evento...</p>;
    }

    if (error) {
        return <p>Error: {error}</p>;
    }

    if (!promotion) {
        return <p>Evento no encontrado.</p>;
    }

    return (
        <div className="event-detail-page">
            <div className="event-main-content">
                <div className="event-image-container">
                    <img src={promotion.graphicPieceUrl} alt={promotion.title} className="event-main-image" />
                </div>
                <div className="right-column-wrapper">
                    <div className="modal-text-left">
                        <h1>{promotion.title}</h1>
                        <p>{promotion.description}</p>
                        <h2>{promotion.choiceText}</h2>
                    </div>

                    {promotion.dates && promotion.dates.length > 0 && (
                        <div className="date-selection-container" style={{ marginBottom: '20px' }}>
                            <label htmlFor="promotion-date" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Selecciona una fecha:</label>
                            {promotion.dates.length > 1 ? (
                                <select
                                    id="promotion-date"
                                    value={selectedDate}
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }}
                                >
                                    {promotion.dates.map(date => (
                                        <option key={date} value={date}>{date}</option>
                                    ))}
                                </select>
                            ) : (
                                <p style={{ padding: '10px', border: '1px solid #eee', borderRadius: '4px', backgroundColor: '#f9f9f9' }}>Fecha disponible: <strong>{promotion.dates[0]}</strong></p>
                            )}
                        </div>
                    )}

                    <div className="options-list">
                        {promotion.options.map((option, index) => (
                            <div key={option.id || index} className="option-card">
                                {option.imageUrl && option.imageUrl.length > 0 && <img src={option.imageUrl[0]} alt={option.name} className="option-image" />}
                                <div className="option-content">
                                    <h3>{option.name}</h3>
                                    <p>{option.capacityText}</p>
                                    <p className="price">{new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(option.price)}</p>
                                    <button onClick={() => openModal(option)} className="btn-book">Reservar ahora</button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {selectedOption && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="close-button" onClick={closeModal}>&times;</button>
                        {selectedOption.imageUrl && selectedOption.imageUrl.length > 0 && (
                            <div className="modal-image-gallery">
                                {selectedOption.imageUrl.map((url, index) => (
                                    <img key={index} src={url} alt={`Option Image ${index}`} className="modal-gallery-image" />
                                ))}
                            </div>
                        )}
                        <div className="modal-details-layout">
                            <div className="modal-text-left">
                                <h2>{selectedOption.modalTitle}</h2>
                                <p>{selectedOption.modalDescription}</p>
                            </div>
                            <div className="modal-services-right">
                                <h4>Servicios Incluidos:</h4>
                                <ul>
                                    {selectedOption.includedServices.map((service, index) => (
                                        <li key={index}>{service}</li>
                                    ))}
                                </ul>
                                <p className="price">Total: {new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP' }).format(selectedOption.price)}</p>
                            </div>
                        </div>
                        <button onClick={() => handleBookNowInModal(selectedOption)} className="btn-book-modal">Confirmar y Proceder al Pago</button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default PromotionDetailPage;